document.addEventListener('DOMContentLoaded', () => {
  const maxPhoneDigits = 11;

  if (typeof window.intlTelInput !== 'function') {
    return;
  }

  document
    .querySelectorAll('input[type="tel"]:not([disabled])')
    .forEach((input) => {
      if (input.classList.contains('intl-tel-input-applied')) {
        return;
      }

      window.intlTelInput(input, {
        initialCountry: 'be',
        preferredCountries: ['be', 'nl'],
        onlyCountries: ['be', 'nl'],
        nationalMode: false,
        placeholderNumberType: 'MOBILE',
        formatAsYouType: true,
        utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.0.4/build/js/utils.js',
      });
      input.classList.add('intl-tel-input-applied');
      input.setAttribute('inputmode', 'tel');
      input.setAttribute('pattern', '[0-9+() -]*');

      input.addEventListener('input', () => {
        let digitCount = 0;
        const sanitizedValue = [...input.value]
          .filter((character, index) => {
            if (/\d/.test(character)) {
              digitCount += 1;
              return digitCount <= maxPhoneDigits;
            }

            return /[ ()-]/.test(character) || (character === '+' && index === 0);
          })
          .join('');

        if (input.value !== sanitizedValue) {
          input.value = sanitizedValue;
        }
      });
    });
});
